import { Dna, User, Calendar, ShoppingBag, MessageCircle } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { setPage, setProfileViewing, setDayMenuDate, setDayMenuOtherUserDate, setShowMenu, setShowSettings, setShowShareCalendar } from '../Redux/store';

const items = [
  // { id: 'match', label: 'Match', Icon: Dna }, // Do not delete, keep commented out
  { id: 'profile', label: 'Profile', Icon: User },
  { id: 'calendar', label: 'Calendar', Icon: Calendar },
  // { id: 'store', label: 'Store', Icon: ShoppingBag }, // Do not delete, keep commented out
  { id: 'chats', label: 'Chats', Icon: MessageCircle },
];

function BottomNav() {
  const current = useSelector((s) => s.ui.currentPage);
  const profile = useSelector((s) => s.user.profile);
  const unreadCount = useSelector((s) => s.chats.unreadCount);
  const dispatch = useDispatch();

  const handleNavClick = (pageId) => {
    // Prevent switching tabs if setup is not complete, unless going to profile
    const firstTimeViews = profile?.first_time_views || {};
    if (pageId !== 'profile' && (!profile || !firstTimeViews.profile_welcome)) {
      dispatch(setPage('profile'));
      return;
    }

    dispatch(setPage(pageId));
    dispatch(setProfileViewing(null));
    dispatch(setDayMenuDate(null));
    dispatch(setDayMenuOtherUserDate(null));
    // Close any open menus/settings when navigating
    dispatch(setShowMenu(false));
    dispatch(setShowSettings(false));
    dispatch(setShowShareCalendar(false));
  };

  return (
    <nav className="shrink-0 z-[10001] pb-[env(safe-area-inset-bottom)]">
      <div className="relative bg-background/95 backdrop-blur shadow-[0_-2px_10px_rgba(0,0,0,0.1)]">
        <ul className="mx-auto flex max-w-xl items-stretch justify-around">
          {items.map(({ id, label, Icon }) => {
            const active = current === id;
            return (
              <li key={id} className="flex-1">
                <button
                  onClick={() => handleNavClick(id)}
                  className={`flex w-full flex-col items-center gap-1 py-2 transition ${active ? 'text-primary' : 'text-muted-foreground'}`}
                >
                  <span className="relative">
                    <Icon size={24} strokeWidth={active ? 2.4 : 1.8} />
                    {id === 'chats' && unreadCount > 0 && (
                      <span className="absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-blue-500 text-[9px] font-bold text-white">
                        {unreadCount > 9 ? '9+' : unreadCount}
                      </span>
                    )}
                  </span>
                  <span className="text-[10px] font-medium">{label}</span>
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
}

export default BottomNav;
